import React from 'react'
import classnames from 'classnames'

import { Left, Body, Right } from 'src/components/Layout/Header'
import { Header } from 'src/components/Layout'
import headerStyles from 'src/components/Layout/Header/header.module.less'
import Spin from 'src/components/Spin'

import loaderStyles from './styles.module.less'

export default function Loading({ brand }) {
  return (
    <div>
      <Header className={headerStyles.header} hideOnDesktop={true}>
        <Left />
        <Body>{brand.name}</Body>
        <Right />
      </Header>
      <div
        className={classnames(
          loaderStyles.spinner,
          loaderStyles.spinnerWithHeader,
          ' c-loader-loading',
        )}
      >
        <Spin />
      </div>
    </div>
  )
}
